import React, { useState } from 'react'
import AdminDashboardLayout from './AdminDashboardLayout'

const SuperAdminPlans = () => {

    const [activeTab, setActiveTab] = useState(0);

    const tabsContent = [
        {
            validity: "14",
            price: "Free Trial",
            discrption: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, est?",
            heading: "Lorem Ipsum",
            planName: "Lorem Plan",
            content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, est?",
            currentPlan: true
        },
        {
            validity: "30",
            price: "$30",
            discrption: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, est?",
            heading: "Lorem Ipsum",
            planName: "Lorem Plan",
            content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, est?",
            currentPlan: false
        },
        {
            validity: "365",
            price: "$120",
            discrption: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, est?",
            heading: "Lorem Ipsum",
            planName: "Lorem Plan",
            content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis, est?",
            currentPlan: false
        },
    ]

    return (
        <>
            <AdminDashboardLayout>
                <div className="subscripiton-plans-box mt-3">
                    <div className="container">
                        <div className="row">
                            {tabsContent.map((tab, index) => (
                                <div className={`col-md-4 mb-4 ${tab.currentPlan ? "currentPlan-box" : ""}`} key={index}
                                    onClick={() => setActiveTab(index)}>
                                    <div className={`subscription-card ${activeTab === index ? 'active-plan-tab' : ''}`}>
                                        <h1>{tab.validity} Days</h1>
                                        <span>{tab.price}</span>
                                        <p>{tab.discrption}</p>
                                        <span className="current-plan">Current Plan</span>
                                    </div>
                                </div>
                            ))}

                            <div className="tab-content">
                                <div className="content-headings">
                                    <h1>{tabsContent[activeTab].heading}</h1>
                                    <h1>Validity {tabsContent[activeTab].validity} days</h1>
                                </div>
                                <p>{tabsContent[activeTab].discrption}</p>
                                <div className="content-headings mt-4">
                                    <h1>{tabsContent[activeTab].planName}</h1>
                                </div>
                                <p>{tabsContent[activeTab].content}</p>

                                <div className="submit-btn-form d-flex justify-content-center mt-5">
                                    <button type="submit" className="btn btn-primary">Proceed</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </AdminDashboardLayout>
        </>
    )
}

export default SuperAdminPlans